import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LogIn, HardHat } from 'lucide-react';

function formatError(detail) {
  if (!detail) return 'Errore sconosciuto';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(' ');
  return String(detail);
}

export default function LoginPage() {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      <div className="hidden lg:flex lg:w-1/2 bg-surface-dark relative overflow-hidden items-center justify-center">
        <img src="https://images.unsplash.com/photo-1723107638733-16ef49e5d4de?w=1200&q=80" alt="Cantiere" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="relative z-10 p-12 text-white max-w-lg">
          <div className="flex items-center gap-3 mb-8">
            <img src="/edilcima_logo.png" alt="EDIL CIMA SRL" className="h-14 w-14 rounded-md object-contain bg-slate-900 p-1" />
            <div>
              <h1 className="text-3xl font-black tracking-tight">EDIL CIMA S.R.L.</h1>
              <p className="text-xs text-slate-400 tracking-wider">Via XX Settembre 22 - Calcinato (BS)</p>
            </div>
          </div>
          <p className="text-xl font-light leading-relaxed text-slate-300">
            Il gestionale edile intelligente per la tua impresa. Preventivi, cantieri, computi metrici e assistenza AI.
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 bg-surface">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <img src="/edilcima_logo.png" alt="EDIL CIMA SRL" className="h-12 w-12 rounded-md object-contain bg-slate-900 p-1" />
            <h1 className="text-xl font-black tracking-tight">EDIL CIMA S.R.L.</h1>
          </div>

          <h2 className="text-3xl font-extrabold tracking-tight mb-2">Accedi</h2>
          <p className="text-slate-500 mb-8">Inserisci le tue credenziali per accedere al gestionale</p>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm" data-testid="login-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <input data-testid="login-email" type="email" placeholder="Email" className="w-full px-4 py-3 border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary/50" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
            <input data-testid="login-password" type="password" placeholder="Password" className="w-full px-4 py-3 border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-primary/50" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
            <button data-testid="login-submit" type="submit" disabled={loading} className="w-full py-3 bg-primary text-white font-bold rounded-md hover:bg-primary-hover transition-all duration-200 active:scale-95 flex items-center justify-center gap-2 disabled:opacity-50">
              {loading ? 'Caricamento...' : <><LogIn size={18}/> Accedi</>}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
